import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC = () => {
	const { pathname } = useLocation();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	useEffect(() => {
		const toggleVisibility = () => {
			if (window.pageYOffset > 300) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);
		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<>
			{isVisible && (
				<button
					onClick={scrollToTop}
					className="fixed bottom-8 right-8 z-50 p-3 rounded-full bg-white text-black shadow-lg hover:bg-zinc-200 transition-all duration-300 animate-in fade-in zoom-in"
					aria-label="Nach oben scrollen"
				>
					<ChevronUp className="w-6 h-6" />
				</button>
			)}
		</>
	);
};

export default ScrollToTop;
